import React, { useCallback, useEffect, useState } from "react";
import { Button, notification } from "antd";
import TobNavBar from "../../DashBaord/Top_navbar";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { listWinningCouponCache } from "../../../controllers/V1/hourlyGamesController";
import { usePermissions } from "../../../controllers/PermissionContext";
import "./hourlyAnalyserResponsive.css";

const formatTtl = (ttlSeconds = 0) => {
  const seconds = Number(ttlSeconds || 0);
  if (seconds <= 0) return "Expired";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours <= 0) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
};

export default function WinningCouponsCache() {
  const hourlyAnalyserPermission = usePermissions("hourlyAnalyser");
  const canViewWinningCouponsCache =
    hourlyAnalyserPermission?.fullAccess === "Y" ||
    hourlyAnalyserPermission?.winningCouponsCache === "Y";
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const fetchList = useCallback(async () => {
    if (!canViewWinningCouponsCache) {
      setRows([]);
      return;
    }
    try {
      setIsLoading(true);
      const res = await listWinningCouponCache();
      if (res?.status !== true) {
        throw new Error(res?.message || "Unable to fetch winning coupon cache.");
      }
      setRows(Array.isArray(res?.result) ? res.result : []);
    } catch (error) {
      setRows([]);
      notification.error({
        message: "Unable to load cache",
        description: error?.message || "Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  }, [canViewWinningCouponsCache]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <>
      <LoadingEffect isLoading={isLoading} />
      <div className="container-fluid hourly-page-container">
        <TobNavBar title="Hourly Winning Coupons" />
        <div className="inventory_tabs_main_div">
          {!canViewWinningCouponsCache ? (
            <div className="text-center py-5">
              You do not have permission to view Winning Coupons.
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <div>
                  <h4 className="mb-1">Today Winning Coupons</h4>
                  {/* <p className="mb-0 text-muted">
                    Winning coupons announced in the last 23 hours.
                  </p> */}
                </div>
                <Button type="primary" onClick={fetchList} disabled={isLoading}>
                  Refresh
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Game</th>
                      <th>Winning Coupon</th>
                      <th>Expires In</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <SkeltonList row={6} col={4} />
                    ) : rows.length ? (
                      rows.map((row, index) => (
                        <tr key={row.cache_key || index}>
                          <td>{index + 1}</td>
                          <td>{row.game_name || "-"}</td>
                          <td>{row.winning_coupon || "-"}</td>
                          <td>{formatTtl(row.ttl_seconds)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          No winning coupons in cache right now.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
